<template>
	<div class="main-product main-product-detail product-main-info">
		<div class="main-product-container">
			<h2 class="text-capitalize product-name">{{ render_product.name }}</h2>
			<div class="text-uppercase product-price product-text-bold">
				<strong>Precio:</strong>
				<!-- <span class="item-gray line-throught">${{ parseInt(render_product.original_price).toFixed(2) }}</span>
		    <span class="item-blue">${{ (render_product.original_price - (render_product.original_price * (render_product.discount_percentage / 100))).toFixed(2) }}</span> -->
		    	<span class="item-gray line-throught" v-if="parseInt(render_product.discount_percentage)">${{ accounting.formatMoney(render_original_price, '') }}</span>
		    	<span class="item-blue">${{ accounting.formatMoney(render_price.toFixed(2), '') }}</span>
          <div class="item-card-shipping-wrap">
            <div class="item-card-shipping" v-if="product.volume === 0">Envío Gratis</div>
          </div>
		    </div>
		    <div class="text-uppercase product-text-bold">
		    	<!-- COLOR 1 -->
				<strong>Color 1:</strong>
				<div class="wrapper-flexbox">
					<div v-for="item in render_colors.primary" data-toggle="tooltip" :title="item.name" class="product-span-color primary color-border" :style="`background-color: ${ item.color }`" @click="primaryColor($event, item)"></div>
				</div>
			</div>
			<div class="text-uppercase product-text-bold">
				<!-- COLOR 2 -->
				<strong v-if="render_colors.secondary.length">Color 2:</strong>
				<div class="wrapper-flexbox">
					<div v-for="item in render_colors.secondary" data-toggle="tooltip" :title="item.name"  :data-color="item.color" class="product-span-color secondary color-border disabled-color" :style="`background-color: ${ item.color }`" @click="secondColor($event, item)"></div>
				</div>
			</div>

			<div class="form-inline" :class="{ invisible: !Math.ceil(render_product.original_price_S) || !Math.ceil(render_product.original_price_L) }">
			  	<div class="form-group">
				    <label for="material" class="text-uppercase product-text-bold">Tamaño:</label>
				    <select class="form-control" name="material" v-model="size" @change="changeSize">
				    	<option value="M">Standard</option>
				    	<option v-if="Math.ceil(render_product.original_price_S)" value="S">Large</option>
				    	<option v-if="Math.ceil(render_product.original_price_L)" value="L">Extra Large</option>
				    </select>
		  		</div>
			</div>
			<!-- <div class="form-inline" :class="{ invisible: !Math.ceil(render_product.original_price_S) && !Math.ceil(render_product.original_price_L) }">
				<label for="without-material" class="text-uppercase product-text-bold">Tamaño:</label>
				<input type="text" class="form-control" id="without-material" disabled value="Standard"/>
			</div> -->
		<div class="row">
			<div class="item-breakpoint">
				<div class="col-sm-4">
				    <div class="input-group">
				      <span class="input-group-btn">
				        <button class="btn btn-default btn-group-custom" @click="quantityMinus" type="button">
				        	<i class="glyphicon glyphicon-minus"></i>
				        </button>
				      </span>
				      <input type="text" class="form-control btn-group-custom text-center" v-model="quantity" disabled value="1" style="height: 34px;">
				      <span class="input-group-btn">
				        <button class="btn btn-default btn-group-custom" @click="quantityPlus" type="button">
				        	<i class="glyphicon glyphicon-plus"></i>
				        </button>
				      </span>
				    </div>
				</div>
				<div class="col-sm-5 padding-extra full-width">
					<button class="btn btn-black btn-lg disabled" v-if="render_product.stock == 0">
						Producto agotado
					</button>
					<button class="btn btn-black btn-lg" v-else @click="addProduct(user, render_product, quantity, size)">
						Agregar al carrito
					</button>
				</div>
			</div>
			<div class="item-breakpoint">
				<div class="col-sm-1 padding-extra">
					<button class="btn btn-black btn-lg btn-heart" style="padding: 9px 32px 9px 16px" @click="toggleFavorite(user, render_product)">
						<i class="item-heart" :class="{ 'item-heart-active': render_is_favorite }"></i>
					</button>
				</div>
			</div>
		</div>

		<!-- Notify me -->
		<div class="notify-me" v-if="!render_product.stock">
			<div class="row">
				<div class="col-xs-12">
					<p><a href="" @click.prevent="notifyStock()">Notificarme</a> cuando este producto esté en stock</p>
				</div>
			</div>
		</div>

		<div class="product-rate">
			<div class="row">
				<product-detail-rate :rate="render_rate" :ratings="render_ratings"></product-detail-rate>
			</div>
		</div>
		<div class="product-list">
			<div class="row">
				<ul class="main-product-list no-margin">
					<li>
						<img src="../../images/entrega.png" alt="" class="img-responsive pull-left">
						<p><strong class="text-uppercase product-text-bold">Tiempo de entrega: </strong>{{ render_product.shipping_time }}</p>
					</li>
					<li>
						<img src="../../images/envios.png" alt="" class="img-responsive pull-left">
						<p><strong class="text-uppercase product-text-bold">Envíos: </strong> A todo México</p>
					</li>
					<li>
						<img src="../../images/garantia.png" alt="" class="img-responsive pull-left">
						<p><strong class="text-uppercase product-text-bold">Garantía y servicio de calidad lasddi</strong></p>
					</li>
				</ul>
			</div>
		</div>
		<div class="social-network">
			<div class="row">
				<div class="col-sm-12">
					<div class="main-product-footer">
						<p class="product-text-bold text-uppercase"><strong>Compartir</strong></p>
						<div class="social-network">
							<!-- FACEBOOK -->
							<a href="" @click="shareFB">
								<i class="fa fa-facebook fa-fw" aria-hidden="true"></i>
							</a>
							<!-- TWITTER -->
							<a href="https://twitter.com/intent/tweet?text={{ render_product.name }} - &url=https://lasddi.com{{ $route.path }}">
								<i class="fa fa-twitter fa-fw" aria-hidden="true"></i>
							</a>
							<!-- PINTEREST -->
							<a data-pin-do="buttonPin" data-pin-custom="true" data-pin-href="https://www.pinterest.com/pin/create/button/?url=https://lasddi.com{{ $route.path }}&media={{ render_main_image }}&description={{ render_product.name }} - https://lasddi.com{{ $route.path }}" data-pin-log="button_pinit">
								<i class="fa fa-pinterest fa-fw" aria-hidden="true"></i>
							</a>
						</div>
						<br>
					</div>
				</div>
			</div>
		</div>

		<!--
		 * Modal
		 -->

		<div class="modal fade" id="notify-modal" tabindex="-1" role="dialog" aria-labelledby="notify-modal">
		  <div class="modal-dialog" role="document">
		    <form @submit.prevent="notifyStock(1)" class="modal-content">
		      <div class="modal-header">
		        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
		        <h4 class="modal-title text-uppercase" id="notify-modal">Notificarme</h4>
		      </div>
		      <div class="modal-body">
		      	<p>Seras notificado por correo cuando el producto este disponible en stock.</p>
		        <div class="form-group">
		        	<label for="notify-email" class="control-label">Email</label>
		        	<input type="text" id="notify-email" v-model="email" class="form-control" placeholder="Email">
		        </div>
		      </div>
		      <div class="modal-footer">
		        <button type="submit" class="btn btn-black">Notificarme</button>
		      </div>
		    </form>
		  </div>
		</div>
	</div>
</template>

<style scoped>
.row {
	padding-top: 15px;
}
.disabled-color {
	opacity: 0.2;
}
.active-color {
	opacity: 1;
}
.product-name {
	padding-bottom: 0;
}
.product-price {
	margin-bottom: 20px;
}
</style>
<script>
import ProductDetailRate from './Product-detail-rate.vue';
import { router } from '../../routes/routes';
import { toast } from '../../scripts/toast';
import { convertToUrl } from '../../scripts/convert_name';
import accounting from '../../scripts/accounting';
import {
	setCurrentProduct,
	addProductShoppingCart,
	addProductWishList,
	removeProductWishList,
	getCurrentProductRatings,
	setCurrentProductParent,
	setCurrentProductVariation,
	resetCurrentProductParent,
	resetRandomProducts,
	notifyMe
} from '../../store/actions';

export default {
	data() {
		return {
			email: '',
			quantity: 1,
			is_favorite: false,
			size: 'M',
			ogl_price: null,
			price: null,
			color_p: null,
			color_s: null,
			extra_colors: false,
			colors: {},
			accounting
		};
	},

	vuex: {
		getters: {
			product: state => state.current_product,
			user: state => state.current_user,
			wish_list: state => state.wish_list,
			ratings: state => state.current_product_ratings,
			parent: state => state.current_product_parent
		},
		actions: {
			setCurrentProduct,
			addProductShoppingCart,
			addProductWishList,
			removeProductWishList,
			getCurrentProductRatings,
			setCurrentProductParent,
			setCurrentProductVariation,
			resetCurrentProductParent,
			resetRandomProducts,
			notifyMe
		}
	},

	computed: {
		render_product() {
			this.ogl_price = this.product.original_price;
			this.price = this.product.price;

			if (!this.product.childs) {
				this.product.childs = [];
			}

			return this.product;
		},

		render_parent () {
			return this.parent || {};
		},

		render_rate () {
			return this.product.rating;
		},

		render_main_image () {
			if (this.product.images && this.product.images.length) {
				return this.product.images[0].route;
			}

			return '';
		},

		render_original_price () {
			return this.ogl_price || 0;
		},

		render_price () {
			return this.price || 0;
		},

		render_is_favorite() {
      		for (var i = 0; i < this.wish_list.length; i++) {
		        if (this.product.id == this.wish_list[i].product_id) {
	        		this.is_favorite = true;
	          		return true;
	        	}
	      	}

			this.is_favorite = false;
			return false;
    	},

    	render_ratings () {
    		return this.ratings;
    	},

    	render_colors () {
    		// let complements = $('.complements');
	    	// let product_details = $('.main-product-detail');
	    	// let $win = $(window);
    		let colors = {
    			primary: [],
    			secondary: []
    		};

			// this is fuck bad.
	    	// if ($win.width() >= 976) {
	    	// 	setTimeout(() => {
	    	// 		let img = $('.complements-item img');

	    	// 		if (!this.colors.secondary || !this.colors.secondary.length) {
	    	// 			img.height(110);
	    	// 		}

		    // 		complements.height(product_details.height());
		    // 	}, 0);
    		// }

    		// if ($win.width() < 976) {
    		// 	setTimeout(() => {
    		// 		// img.height(100);
		    // 		complements.height(250);
		    // 	}, 0);
    		// }

    		// if ($win.width() < 767) {
    		// 	setTimeout(() => {
    		// 		img.height(100);
		    // 		complements.height(700);
		    // 	}, 0);
    		// }

    		setTimeout(() => {
					$('[data-toggle="tooltip"]').tooltip();
				}, 0);

    		if (this.parent) {
	    		if (!this.parent.id) {
	    			return colors;
	    		}

	    		if (this.parent.childs.length) {
	    			colors = this.getColors(this.parent);
	    		} else {
	    			colors.primary.push({ name: this.product.color_name, color: this.product.color });

	    			if (this.product.color2)
	    				colors.secondary.push({ name: this.product.color2_name, color: this.product.color2 });
	    		}
    		} else if (this.product.id) {
    			if (this.product.childs.length) {
    				colors = this.getColors(this.product);
    			} else {
    				colors.primary.push({ name: this.product.color_name, color: this.product.color });

    				if (this.product.color2)
    					colors.secondary.push({ name: this.product.color2_name, color: this.product.color2 });
    			}
    		}

    		return colors;
    	}
	},

	methods: {
		shareFB (e) {
			e.preventDefault();
			let image = null;

			if (this.product.images.length) {
				image = this.product.images[0].route;
			} else {
				image = '';
			}

			FB.ui({
				method: 'share',
				href: 'https://lasddi.com',
				title: `${ this.product.name } - https://lasddi.com${ this.$route.path }`,
				picture: image
			}, res => {
				console.log(res);
			});
		},

		quantityPlus() {
			/* add 1 item to buy. */
			this.quantity++;
		},

		getColors (product) {
			let is_equal_p = false;
			let is_equal_s = false;
			let colors = {
				primary: [],
				secondary: []
			};

			colors.primary = [];
			colors.secondary = [];

			if (product.color) {
				colors.primary.push({ name: product.color_name, color: product.color, color2: product.color2 });
			}

			if (product.color2) {
				colors.secondary.push({ name: product.color2_name, color: product.color2 });
			}

			for (let i = 0, p = product.childs; i < p.length; i++) {
				for (let j = 0, c = colors.primary; j < c.length; j++) {
					if (p[i].color == c[j].color) {
						is_equal_p = true;
					}
				}

				for (let j = 0, c = colors.secondary; j < c.length; j++) {
					if (p[i].color2 == c[j].color) {
						is_equal_s = true;
					}
				}

				if (!is_equal_p && p[i].color) {
					colors.primary.push({ name: p[i].color_name, color: p[i].color, color2: p[i].color2 });
				}

				if (!is_equal_s && p[i].color2) {
					colors.secondary.push({ name: p[i].color2_name, color: p[i].color2 });
				}

				is_equal_s = false;
				is_equal_p = false;
			}

			if (colors.secondary.length > 1) {
				this.extra_colors = true;
			}

			this.colors = colors;
			return colors;
		},

		quantityMinus() {
			/* Cannot set quantity minus of 1, nobody buys 0 items. */
			if (this.quantity == 1) {
				return;
			}
			/* remove 1 item to buy. */
			this.quantity--;
		},

		changeProduct() {
			/* check changes in the route to obtain the new one. */
			router.afterEach(transition => {
				// solves an issue with nested zoom images.
				$('.zoomImg').remove();
				this.size = 'M';
				this.quantity = 1;
				if (this.$route.name == 'product_detail') {
					this.color_p = null;
					this.color_s = null;
					this.resetCurrentProductParent();
					this.resetRandomProducts();
					// this.setCurrentProductParent(this.$route.params.id);
					this.setCurrentProduct(this.$route.params.id);
					// this.getCurrentProductRatings(this.$route.params.id);
					$('[data-toggle="tooltip"]').tooltip('destroy');
				}
			});
		},

		changeSize () {
			switch (this.size) {
				case 'S':
					this.ogl_price = this.product.original_price_S;
					this.price = this.product.price_S;
					this.setCurrentProductVariation('S');
					break;
				case 'M':
					this.ogl_price = this.product.original_price;
					this.price = this.product.price;
					this.setCurrentProductVariation('M');
					break;
				case 'L':
					this.ogl_price = this.product.original_price_L;
					this.price = this.product.price_L;
					this.setCurrentProductVariation('L');
					break;
				default:
					toast({
						title: 'Tamaños',
						content: 'No hay precios para ese tamanio'
					});
			}
		},

		toggleFavorite(user, product) {
			if (this.is_favorite) {
				this.removeProductWishList(user, product);
			} else {
				this.addProductWishList(user, product);
			}
	    },

	    addProduct (user, product, quantity, size) {
	    	let allow_buy = false;
	    	// check if are products in stock.
	    	switch (size) {
	    		case 'S':
	    			if (product.stock_S != 0) {
	    				allow_buy = true;
	    			}
	    			break;
	    		case 'L':
	    			if (product.stock_L != 0) {
	    				allow_buy = true;
	    			}
	    			break;
	    		default:
	    			if (product.stock != 0) {
	    				allow_buy = true;
	    			}
	    	}

	    	if (allow_buy) {
	    		return this.addProductShoppingCart(user, product, quantity, size);
	    	}

	    	toast({
	    		title: 'Carrito de Compras',
	    		content: 'Producto agotado.'
	    	});
	    },

	    primaryColor (e, color_p) {
	    	this.color_p = color_p;

	    	if (!this.colors.secondary || this.colors.secondary.length < 2) {
	    		let product = this.searchProductByColor();

	    		if (product.id == this.product.id) {
		    		$('.product-span-color.primary').removeClass('active');
		    		$('.product-span-color.secondary').removeClass('active');

		    		return toast({
		    			title: 'Colores',
		    			content: 'Estás en esta variación del producto.'
		    		});
		    	}

	    		if (product.id != -1 && product.id != this.product.id) {
		    		router.go('/product/' + convertToUrl(product));
		    	}

		    	return;
	    	}

	    	$('.product-span-color.primary').removeClass('active');
	    	$('.product-span-color.secondary').removeClass('active');
	    	$(e.target).addClass('active');

	    	toast({
	    		title: 'Colores',
	    		content: 'Selecciona un color de patas.'
	    	});
	    	this.getValidColors(color_p);
	    },

	    getValidColors (color_p) {
	    	let product = null;
	    	let valid_colors = [];
	    	let $length = $('.secondary').length;

	    	$('.secondary').removeClass('active-color');

	    	if (this.parent) {
	    		product = this.parent;
	    	} else {
	    		product = this.product;
	    	}

	    	if (product.color == color_p.color) {
	    		valid_colors.push(product.color2);
	    	}

	    	for (let i = 0, c = product.childs; i < c.length; i++) {
	    		if (c[i].color == color_p.color) {
	    			valid_colors.push(c[i].color2);
	    		}
	    	}

	    	for (let i = 0, l = $length; i < l; i++) {
	    		let $el = $('.secondary')[i];
	    		let color2 = $($el).data('color');

	    		for (let j = 0, v = valid_colors; j < v.length; j++) {
	    			if (v[j] == color2) {
		    			$($el).addClass('active-color');
		    		}
	    		}
	    	}
	    },

	    secondColor (e, color_s) {
	    	if (!this.color_p.color) {
	    		return toast({
	    			title: 'Colores',
	    			content: 'Primero selecciona el color del cuerpo'
	    		});
	    	}

	    	if (!$(e.target).hasClass('active-color')) {
	    		return;
	    	}

	    	$('.product-span-color.secondary').removeClass('active');
	    	$(e.target).addClass('active');

	    	this.color_s = color_s;
	    	let product = this.searchProductByColors();
	    	this.color_p = null;

	    	if (product.id == this.product.id) {
	    		$('.product-span-color.primary').removeClass('active');
	    		$('.product-span-color.secondary').removeClass('active');

	    		return toast({
	    			title: 'Colores',
	    			content:'Estás en esta variación del producto.'
	    		});
	    	}

	    	if (product.id != -1 && product.id != this.product.id) {
	    		router.go('/product/' + convertToUrl(product));
	    	}
	    	// toast({
	    	// 	title: 'Color Patas',
	    	// 	content: 'Color de patas seleccionado'
	    	// });
	    },

	    searchProductByColors () {
	    	let current_product = {};
	    	let cp = this.color_p.color;
	    	let cs = this.color_s.color;

	    	if (this.parent) {
    			current_product = this.parent;
	    	} else if (this.product.id) {
	    		current_product = this.product;
	    	}

	    	if (current_product.color == cp && current_product.color2 == cs) {
	    		return current_product;
	    	}

	    	for (let i = 0, p = current_product.childs; i < p.length; i++) {
	    		if (p[i].color == cp && p[i].color2 == cs) {
	    			return p[i];
	    		}
	    	}

	    	return -1;
	    },

	    setHeight () {
	    	// let complements = $('.complements');
	    	// let product_details = $('.main-product-detail');
	    	// let $win = $(window);
	    	// this is fuck bad.
	    	// if ($win.width() >= 976) {
	    	// 	setTimeout(() => {
		    // 		complements.height(product_details.height());
		    // 	}, 1000);
    		// }

    		// if ($win.width() < 976) {
    		// 	setTimeout(() => {
		    // 		complements.height(250);
		    // 	}, 500);
    		// }

    		// if ($win.width() < 767) {
    		// 	setTimeout(() => {
		    // 		complements.height(700);
		    // 	}, 500);
    		// }

	    	// $(window).on('resize', e => {
	    	// 	if ($win.width() >= 976) {
	    	// 		complements.height(product_details.height());
	    	// 	}

	    	// 	if ($win.width() < 976) {
	    	// 		complements.height(250);
	    	// 	}

	    	// 	if ($win.width() < 767) {
	    	// 		complements.height(700);
	    	// 	}
	    	// });
	    },

	    searchProductByColor () {
	    	let current_product = {};
	    	let cp = this.color_p.color;

	    	if (this.parent) {
    			current_product = this.parent;
	    	} else if (this.product.id) {
	    		current_product = this.product;
	    	}

	    	if (current_product.color == cp) {
	    		return current_product;
	    	}

	    	for (let i = 0, p = current_product.childs; i < p.length; i++) {
	    		if (p[i].color == cp) {
	    			return p[i];
	    		}
	    	}

	    	return -1;
	    },

	    notifyStock (has_email) {
	    	if (has_email) {
	    		$('#notify-modal').modal('hide')
	    		return this.notifyMe({}, this.product, this.email)
	    	}

	    	if (this.user.token) {
	    		this.notifyMe(this.user, this.product);
	    	} else {
	    		$('#notify-modal').modal('show')
	    	}
	    }
	},

	components:{
		ProductDetailRate,
	},

	ready() {
		this.setHeight();
		this.resetRandomProducts();
		this.resetCurrentProductParent();
		// this.setCurrentProductParent(this.$route.params.id);
		this.setCurrentProduct(this.$route.params.id);
		// this.getCurrentProductRatings(this.$route.params.id);
		this.changeProduct();

		// When show the modal focus the input.
		$('#notify-modal').on('shown.bs.modal', function () {
			$('#notify-email').focus()
		})
	}
};
</script>



// WEBPACK FOOTER //
// Product-detail-general.vue?ce433276